var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5303 19V17C21.5303 15.1362 20.2555 13.5701 18.5303 13.126M15.0303 1.29076C16.4962 1.88415 17.5303 3.32131 17.5303 5C17.5303 6.67869 16.4962 8.11585 15.0303 8.70924M16.5303 19C16.5303 17.1362 16.5303 16.2044 16.2258 15.4693C15.8198 14.4892 15.0411 13.7105 14.061 13.3045C13.3259 13 12.394 13 10.5303 13H7.53027C5.66651 13 4.73462 13 3.99954 13.3045C3.01943 13.7105 2.24073 14.4892 1.83476 15.4693C1.53027 16.2044 1.53027 17.1362 1.53027 19M13.0303 5C13.0303 7.20914 11.2394 9 9.03027 9C6.82113 9 5.03027 7.20914 5.03027 5C5.03027 2.79086 6.82113 1 9.03027 1C11.2394 1 13.0303 2.79086 13.0303 5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.cb26bb8046a2aad1963d3bca2802acf6.svg";
export { ForwardRef as ReactComponent };